import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { IState } from '../../shared/models/state';
import { Actions } from '@ngrx/effects';
import { GET_GLOBAL_SETTINGS_SUCCESS, GetGlobalSettingsAction } from './global-settings.actions';

@Injectable()
export class GlobalSettingsResolve implements Resolve<any> {
  constructor(private store: Store<IState>, private action$: Actions) {}

  resolve(route: ActivatedRouteSnapshot) {
    this.store.dispatch(new GetGlobalSettingsAction());
    return this.action$.ofType(GET_GLOBAL_SETTINGS_SUCCESS).take(1);
  }
}
